import InternalDashboardNav from './InternalDashboardNav';

export default InternalDashboardNav;
